<h2 mat-dialog-title>Update this record</h2>
<mat-dialog-content>If you make changes the component will no longer be approved</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-button [mat-dialog-close]="true" color="primary">Yes</button>
  <button mat-button mat-dialog-close>No</button>
</mat-dialog-actions>
